<template>
    <collapsible-widget>
        <template #name>Sizes</template>
        <template #controls>
            <Badge v-if="selectedValues.length" :count="selectedValues.length" class="filter-badge-count"></Badge>
        </template>
        <library-checkbox-group v-model="selectedValues" :options="options" />
    </collapsible-widget>
</template>

<script lang="ts">
import { DeliverableLibraryAction, DeliverableLibraryGetters } from "@/store/modules/deliverableLibrary";
import LibraryCheckboxGroup from "@/components/Campaign/LibraryCheckboxGroup.vue";
import CollapsibleWidget from "@/components/Campaign/widgets/CollapsibleWidget.vue";

export default {
    name: "LibrarySizeFilter",
    components: {
        CollapsibleWidget,
        LibraryCheckboxGroup
    },

    computed: {
        options() {
            return this.$store.state.deliverableLibrary.filterOptions.masterTemplates;
        },

        selectedValues: {
            get() {
                return this.$store.getters[DeliverableLibraryGetters.sizeFilters];
            },
            set(newValue: string[]) {
                this.$store.dispatch(DeliverableLibraryAction.UpdateSizeFilter, {
                    values: newValue
                });
            }
        }
    }
};
</script>

<style lang="scss">
@use "@style/variables" as *;
</style>
